import client from "./Client";

const createSubscriptionPackage = (payload) => {
  return client.post('/subscription/package/create', { ...payload });
};

const updateSubscriptionPackage = (payload) => {
  return client.patch('/subscription-package/update', { ...payload });
};

const getSubscriptionPackages = () => {
  return client.get('/subscription-packages');
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  createSubscriptionPackage,
  updateSubscriptionPackage,
  getSubscriptionPackages
};
